import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SharedServiceService } from '../../services/shared-service.service';

export type AddHabitRecommendationPayload = {
  loggedInUserId: string;
  habitNameId: string;
  nameId: number;
  cardColour: string;
};

export type AddCareTeamRecommendationPayload = AddHabitRecommendationPayload & {
  memberId: string;
};

@Injectable({
  providedIn: 'root',
})
export class ReminderService {
  private apiBaseUrl: string;

  constructor(
    private http: HttpClient,
    private sharedService: SharedServiceService
  ) {
    this.apiBaseUrl = sharedService.baseUrl();
  }

  getReminderCategories(): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}reminder-categories`;
    return this.http.get(url, { headers });
  }

  getHabitRecommendations(memberId: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const base = this.apiBaseUrl.replace(/\/+$/, '');
    const url = `${base}/habit-recommendations/${encodeURIComponent(memberId ?? '')}`;
    return this.http.get(url, { headers });
  }

  getLoggedInUserId(): string {
    const user = this.sharedService.getLoggedInUser();
    return (user?.id ?? '').toString();
  }

  addHealthRecommendation(payload: AddHabitRecommendationPayload): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}health-recommendations`;
    return this.http.post(url, payload, { headers });
  }

  addCareTeamRecommendation(payload: AddCareTeamRecommendationPayload): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}care-team-recommendations`;
    return this.http.post(url, payload, { headers });
  }
}

